import request from '@/utils/request'
import * as Product from '@/interfaces/product'
import { AxiosPromise } from 'axios'
import { ICategoryRequest, IProductRequest } from '@/interfaces/product'

const path = '/eco'
const app = process.env.VUE_APP_PLATFORM
const version = process.env.VUE_APP_VERSION

export function getCategory (data: any): AxiosPromise<Product.ICategoryResponse> {
  const requestData = { app, ver_no: version, ...data } as IProductRequest | ICategoryRequest
  return request({
    url: `${path}/get_category.php`,
    method: 'post',
    data: requestData
  })
}

export function getProductContentById (data: any): AxiosPromise<Product.IProductResponse> {
  const requestData: Product.IProductContentRequest = { ...data, app, ver_no: version }
  return request({
    url: `${path}/get_product_content.php`,
    method: 'post',
    data: requestData
  })
}
